"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeLineEventCoordinateCoder = void 0;
const _1 = require(".");
class TimeLineEventCoordinateCoder {
    static encode(timeLineEvent, config) {
        const { left, top, width, height } = _1.PeriodCoordinateCoder.encode(timeLineEvent.event.period, config);
        const paddingLeft = this.indentLeft(config.widthPerDay, timeLineEvent.indent);
        const paddingRight = 1;
        return {
            left: left + paddingLeft,
            height,
            width: width - paddingLeft - paddingRight,
            top
        };
    }
    // NOTE: decodeは使わないので書いてない
    static indentLeft(widthPerDay, indent) {
        if (indent === 0) {
            return 0;
        }
        return widthPerDay - widthPerDay / Math.pow(2, indent);
    }
}
exports.TimeLineEventCoordinateCoder = TimeLineEventCoordinateCoder;
//# sourceMappingURL=timeLineEventCoordinateCoder.js.map